import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import Surveytooltip from "./SurveyTooltip";
import SurveyRequired from "./SurveyRequired";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class SurveyMultiFileUpload extends Component {
  state = {
    files: [],
    isDragging: false,
  };

  fileInputRef = React.createRef();

  componentDidMount() {
    const { data, response } = this.props;
    const questionId = data.questionId;

    const matchedResponse = response?.SurveyResponses?.find(
      (r) => r.questionId === questionId
    );

    if (matchedResponse?.fileAttachments?.length > 0) {
      const files = matchedResponse.fileAttachments.map((attachment) => {
        return new File(
          [
            Uint8Array.from(atob(attachment.DocumentBody), (c) =>
              c.charCodeAt(0)
            ),
          ],
          attachment.FileName,
          {
            type: attachment.ContentType || "application/octet-stream",
            lastModified: Date.now(),
          }
        );
      });

      this.setState({ files });

      this.props.setUpdateMultipleFile(
        { required: data.isMandatoryQuestion, data: files },
        this.props.uid,
        data.questionId
      );
    }
  }

  handleFiles = (newFiles) => {
    const files = [...this.state.files, ...Array.from(newFiles)];
    this.setState({ files });

    this.props.setUpdateMultipleFile(
      { required: this.props.data.isMandatoryQuestion, data: files },
      this.props.uid,
      this.props.data.questionId
    );
  };

  handleChange = (e) => {
    this.handleFiles(e.target.files);
  };

  handleRemoveFile = (index) => {
    const files = [...this.state.files];
    files.splice(index, 1);
    this.setState({ files });

    this.props.setUpdateMultipleFile(
      { required: this.props.data.isMandatoryQuestion, data: files },
      this.props.uid,
      this.props.data.questionId
    );
  };

  handleDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragging: true });
  };

  handleDragLeave = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });
  };

  handleDrop = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      this.handleFiles(e.dataTransfer.files);
      e.dataTransfer.clearData();
    }
  };

  handleClick = () => {
    this.fileInputRef.current.click();
  };

  render() {
    const { data } = this.props;
    const { files, isDragging } = this.state;

    return (
      <Form.Group>
        <div className="surveyquestions" id={this.props.data.relatedToQuestionId ? this.props.data.relatedToQuestionId : ""}>
          <p>
            {data.question}
            {data.isMandatoryQuestion && <SurveyRequired />}
            {data.questionTooltip && (
              <Surveytooltip text={data.questionTooltip} />
            )}
          </p>

          {/* File list */}
          <div className="mt-1">
            {files.length > 0 ? (
              files.map((file, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center mb-1"
                  
                >
                  <span>🗎  {file.name}</span>
                  <span
                    style={{ cursor: "pointer", color: "black", marginLeft: 8 }}
                    onClick={() => this.handleRemoveFile(index)}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </span>
                </div>
              ))
            ) : (
              <span className="text-muted">Ingen filer er valgt</span>
            )}
          </div>

          {/* Drag-and-drop area (clickable) */}
          <div
          style={{cursor: "pointer"}}
            onDragOver={this.handleDragOver}
            onDragLeave={this.handleDragLeave}
            onDrop={this.handleDrop}
            onClick={this.handleClick}
            className={`border p-4 mt-2 text-center ${
              isDragging ? "border-primary bg-light" : "border-secondary"
            } drag-drop-area`}
          >
            <p className="mb-0">Dra og slipp filer her eller klikk for å velge</p>
            <input
              type="file"
              ref={this.fileInputRef}
              hidden
              multiple
              onChange={this.handleChange}
            />
          </div>
        </div>
      </Form.Group>
    );
  }
}
